import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-item" }
const _hoisted_2 = { class: "export-content-container" }
const _hoisted_3 = { class: "export-item-name" }
const _hoisted_4 = { class: "export-progress-container" }

import { computed, inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';
import useListingNames from 'vcomponents/listing/apiListing/mapping/ListingNames';
import ExportProgressColumn from 'vcomponents/listing/tableColumns/ExportProgressColumn.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportItem',
  props: {
    item: {
        type: Object,
        required: true,
        default: () => {},
    },
},
  setup(__props) {

const $t = inject('$t') as Translator;

const ListingNames = useListingNames();

const props = __props;

const name = computed(() => {
    let name = '';
    if (props.item['custom_name']) {
        name = props.item['custom_name'];
    } else {
        const date = window.sellsyapp.config.globalProperties.$filters.dateFormatter(
            props.item['created_at'],
            'SLASHED_DATE_TIME',
            false,
        );
        const listingName =
            ListingNames[props.item['listing_name']] !== undefined
                ? ListingNames[props.item['listing_name']].toLowerCase()
                : props.item['listing_name'];
        name = $t.__('export.notifications.exportName', { type: listingName, date });
    }
    return name;
});

const startedAt = computed(() => {
    return props.item.started_at ? moment(props.item.started_at) : null;
});

const download = () => {
    if (props.item.status === 'succeed' && props.item.public_url) {
        window.open(props.item.public_url, '_blank');
    }
};

return (_ctx: any,_cache: any) => {
  const _component_CompassIconButton = _resolveComponent("CompassIconButton")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createVNode(_component_CompassIconButton, {
          icon: "download",
          size: _ctx.CompassEnums.IconButtonSize.MEDIUM,
          disabled: __props.item.status != 'succeed' || !__props.item.public_url,
          onClick: download
        }, null, 8 /* PROPS */, ["size", "disabled"]),
        _createElementVNode("span", _hoisted_3, " " + _toDisplayString(name.value), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ExportProgressColumn, {
        status: __props.item.status,
        progress: __props.item.progress,
        started_at: startedAt.value
      }, null, 8 /* PROPS */, ["status", "progress", "started_at"])
    ])
  ]))
}
}

})